import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Home from "./sections/Home";
import Photos from "./sections/Photos";
import WeddingInfo from "./sections/WeddingInfo";
import Hotel from "./sections/Hotel";
import Rsvp from "./sections/Rsvp";
import Schedule from "./sections/Schedule";
import WeddingSchedule from "./sections/WeddingSchedule";
import Faq from "./sections/Faq";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Home />
      <Photos />
      <WeddingInfo />
      <Rsvp />
      <Schedule />
      <Hotel />
      <WeddingSchedule />
      <Faq />
      <Footer />
    </div>;
}